var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardNoSensors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E30613;}\n\t.st1{opacity:0.15;fill:#B1B7C5;}\n\t.st2{clip-path:url(#SVGID_1_);}\n\t.st3{fill:#B1B7C5;}\n\t.st4{fill:#808693;}\n\t.st5{fill:#FCFCFC;}\n\t.st6{fill:#EFF1F3;}\n\t.st7{fill:#E6E6E6;}\n\t.st8{opacity:0.72;fill:#B1B7C5;}\n\t.st9{fill:#00BDAA;}\n\t.st10{opacity:0.72;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.5,
    cy: 283.5,
    r: 212.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.1,244.5h-53c-7.1,0-12.7,5.6-12.7,12.7v53c0,7.1,5.6,12.7,12.7,12.7h53c7.1,0,12.7-5.6,12.7-12.7v-53 C321.8,250.3,316.2,244.5,309.1,244.5z M282.6,303.1c-10.6,0-19.4-8.6-19.4-19.4s8.6-19.4,19.4-19.4s19.4,8.6,19.4,19.4 S293.2,303.1,282.6,303.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M359.9,255.7c0-12.7-5-24.8-14-33.8c-9-9-21.1-14-33.8-14v8c10.6,0,20.7,4.1,28.2,11.6 c7.5,7.5,11.6,17.4,11.6,28.2H359.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M357.5,210.3c-12.1-12.1-28.2-18.7-45.4-18.7v8c15.1,0,29.3,5.8,39.8,16.6c10.6,10.6,16.6,24.8,16.6,39.8h8 C376.5,238.5,369.8,222.3,357.5,210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.1,223v8c6.7,0,12.7,2.6,17.4,7.3c4.7,4.7,7.3,10.8,7.3,17.4h8c0-8.8-3.4-17-9.5-23 C329.1,226.4,320.9,223,312.1,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207,311.2c0,12.7,5,24.8,14,33.8c9,9,21.1,14,33.8,14v-8c-10.6,0-20.7-4.1-28.2-11.6 c-7.5-7.5-11.6-17.4-11.6-28.2H207z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M209.4,356.7c12.1,12.1,28.2,18.7,45.4,18.7v-8c-15.1,0-29.3-5.8-39.8-16.6c-10.6-10.6-16.6-24.8-16.6-39.8 h-8C190.5,328.5,197.1,344.6,209.4,356.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M254.8,344v-8c-6.7,0-12.7-2.6-17.4-7.3s-7.3-10.8-7.3-17.4h-8c0,8.8,3.4,17,9.5,23 C237.8,340.5,246,344,254.8,344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.7,207c-12.7,0-24.8,5-33.8,14c-9,9-14,21.1-14,33.8h8c0-10.6,4.1-20.7,11.6-28.2 c7.5-7.5,17.4-11.6,28.2-11.6V207z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.3,209.4c-12.1,12.1-18.7,28.2-18.7,45.4h8c0-15.1,5.8-29.3,16.6-39.8c10.6-10.6,24.8-16.6,39.8-16.6v-8 C238.5,190.5,222.3,197.1,210.3,209.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M223,254.8h8c0-6.7,2.6-12.7,7.3-17.4c4.7-4.7,10.8-7.3,17.4-7.3v-8c-8.8,0-17,3.4-23,9.5 C226.4,237.8,223,246,223,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.2,359.9c12.7,0,24.8-5,33.8-14s14-21.1,14-33.8h-8c0,10.6-4.1,20.7-11.6,28.2 c-7.5,7.5-17.4,11.6-28.2,11.6V359.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M356.7,357.5c12.1-12.1,18.7-28.2,18.7-45.4h-8c0,15.1-5.8,29.3-16.6,39.8c-10.6,10.6-24.8,16.6-39.8,16.6v8 C328.5,376.5,344.6,369.8,356.7,357.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M344,312.1h-8c0,6.7-2.6,12.7-7.3,17.4c-4.7,4.7-10.8,7.3-17.4,7.3v8c8.8,0,17-3.4,23-9.5 C340.5,329.1,344,320.9,344,312.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNoSensors);
export default __webpack_public_path__ + "static/media/dashboard_no_sensors.ffe313cf393525680507831e77c8817d.svg";
export { ForwardRef as ReactComponent };